module.exports = __webpack_public_path__ + "img/08_WebFlow_13-2.55193e7c.svg";